<script lang="ts" setup>
import Hot from './components/hot/index.vue';
import Content from './components/content/index.vue';
import CommunityCard from './components/CommunityCard.vue';
import OperationCard from './components/OperationCard.vue';
import Footer from './components/Footer.vue';
import Sidebar from './components/Sidebar.vue';
import ScrollToTop from './components/ScrollToTop.vue';

const props = defineProps({
  options: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<template>
  <section class="bg-hex-fff pb-80">
    <Sidebar />
    <ScrollToTop />
    <div>
      <Hot v-if="props.options.HotList == 1" />
    </div>
    <div class="container">
      <div class="flex justify-between pt-40">
        <div class="flex-grow">
          <Content v-if="props.options.Recommend == 1" />
        </div>
        <div class="ml-40 w-376 flex-shrink-0">
          <CommunityCard v-if="props.options.CommunityCard == 1" />
          <OperationCard v-if="props.options.OperationCard == 1" />
          <Footer />
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>
